import { render } from "./AddAdvertisementBanner.vue?vue&type=template&id=2530761c"
import script from "../js/add-advertisement-banner.js?vue&type=script&lang=js"
export * from "../js/add-advertisement-banner.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__